import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import useFetch from '../../Services/useFetch';
import entities from '../../utils/entities';
import { Button, Row, Col, Container, FormGroup } from 'reactstrap';
import FormInput from '../Form/FormInput';
import Editor from '../Models/Editor';
import ReactImageGallery from 'react-image-gallery';
import AircraftCategorySelector from '../Form/AircraftCategorySelector';
import { getIn, useFormikContext } from 'formik';
import { useAlert } from '../../Services/AlertContext';
import useFetchSimple from '../../Services/useFetchSimple';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useAuth } from '../../Services/AuthContext';
import ManufacturerSelector from '../Form/ManufacturerSelector';
import BooleanInput from '../Form/BooleanInput';
import FormTextArea from '../Form/FormTextArea';
import SelectSetting from '../Form/SelectSetting';
import { endpoints } from '../../utils/Constants';
import { useEdit } from '../../Services/EditContext';
import { FormLabel } from '../Form/FormLabel';
import Select from '../Form/Selector';
import CompareFormValue from '../Form/CompareFormValue';
import SpecialDocument from '../Editors/SpecialDocument';

const AircraftImages = ({ route, aircraft, newImages, setNewImages, supplierId }) => {
    const [imageList, loading, error, reload] = useFetch(aircraft?.id ? entities.aircraftImages.getByStatus() + aircraft.id : null);
    const [images, setImages] = useState([]);
    const [editImage, setEditImage] = useState();
    const fetch = useFetchSimple();

    const myalert = useAlert();
    const [saving, setSaving] = useState();

    const [auth] = useAuth();
    const [edit] = useEdit();


    const isAdminOrSupplier = auth.role === 'Admin' || auth.role === 'Supplier';

    useEffect(() => {
        if (imageList) {
            const images = imageList.map(x => ({ original: [x.contentType, x.file].join(",") }))
            setImages(images);
        }
    }, [imageList]);
    useEffect(() => {
        if (newImages) {
            const images = newImages.map(x => ({ original: [x.contentType, x.file].join(",") }))
            setImages(images);
        }
    }, [newImages])
    const changeAircraftImages = () => {

        setEditImage(entities.aircraftImages.newItem(aircraft));
    }
    const imageEditorClosed = () => setEditImage(false);
    const saveImage = (values) => {
        const options = { method: 'POST', body: JSON.stringify(values) };
        setSaving(true);
        if (aircraft.id) {
            return fetch(entities.aircraftImages.addSingle, options).then((result) => {
                var ret = result.body;
                if (ret.success) {
                    const m = ret.messages;
                    myalert({
                        title: 'Saved',
                        body: <div>
                            <h5>Saved image.</h5>
                            {m && m.length ? m.map(x => <p>{x}</p>) : null}
                        </div>,
                        onDismiss: () => {
                            setSaving(false);
                            setEditImage();
                        }
                    });
                }
                else {
                    alert({

                        title: 'Saved', body: <div>
                            <h5>Saved image.</h5>
                            {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                        </div>
                        , onDismiss: () => {

                            setSaving(false);

                        }
                    });

                }
            }, (error) => {
                const errors = error?.body?.errors;
                const messages = errors ? Object.keys(errors).map((x, i) => {
                    return <p key={i}>{errors[x].map(y => y)}</p>
                }) : null
                alert({
                    title: 'Error saving image', body: <div>
                        <h3>Unexpected Result</h3>
                        {messages ? messages : JSON.stringify(error)}
                    </div>
                });

                setSaving(false);
            }).catch((e) => {
                alert({ title: 'Error saving image', body: "Exception Result: " + e ? JSON.stringify(e) : 'No Error!' });
                setSaving(false);

            })
        }
        else {
            setNewImages([...newImages, values]);
            setEditImage();
        }

    };

    return <Container>
        {loading ? <LoadingAnimation /> : null}
        {error && <h5>Error<Button onClick={reload}>Retry</Button></h5>}
        {isAdminOrSupplier && edit && <Button onClick={changeAircraftImages}>Set/Change Images</Button>}
        <Editor route={route} entity={entities.aircraftImages} newItem={editImage} editorClosed={imageEditorClosed} onSave={saveImage} />
        {!loading ? !error && images && images.length ? <ReactImageGallery items={images ? images : []} /> : <div style={{ justifyContent: 'center', width: '100%', display: 'flex' }}><Row><h1>No Aircraft Images</h1></Row><h1 style={{ fontSize: "80px" }}><span role="img" aria-label="disappointed">😞</span></h1></div> : null}

    </Container>
}
const AircraftDetail = ({ route, supplierId, isQGov }) => {
    const [equipmentDetailsList, loadingEquimentDetails, errorEquimentDetails] = useFetch(endpoints.getSettings + 'EquipmentDetails');
    const otherEquipmentDetailsId = 'otherEquipmentDetails';
    const [newImages, setNew] = useState([]);
    const [edit] = useEdit();
    const [selection, setSelection] = useState();
    const [originalSelection, setOriginalSelection] = useState();
    const [options, setOptions] = useState(equipmentDetailsList?.map((m) => { return { value: m.referenceId, label: m.value }; }));

    const supplierIdFromRoute = typeof route === 'string'
        ? route.match(/\/manageSuppliers\/([^/]+)\/Aircraft/i)?.[1]
        : undefined;

    if (!supplierId && supplierIdFromRoute) {
        supplierId = supplierIdFromRoute;
    }

    const { values, setFieldValue } = useFormikContext();
    const otherEquipmentDetailsValue = values[otherEquipmentDetailsId];
    const orig = getIn(values, 'original.' + otherEquipmentDetailsId);
    const original = orig ? orig : null;   

    const [docs, loadingSupplierDocs, loadingSupplierDocserror, refresh] = useFetch(endpoints.getSupplierDocumentByFilter + supplierId + "/Active/Aircraft Total Time In Service Summary");

    const setNewImages = (images) => {

        setFieldValue('images', images.map(x => {

            return { ...values, ...x };
        }));
        setNew(images);
    }
    const onAlphaNumericChange = (id, value) => {
        const sanitized = String(value).replace(/[^a-zA-Z0-9-]/g, '');
        setFieldValue(id, sanitized);
    }
    const onChange = (id, value) => {
        const sanitized = String(value).replace(/[^0-9]/g, '');
        setFieldValue(id, sanitized);
    }
    const onSelectChange = val => {

        const newValue = val ? val.map(x => { return x.label }).join(',') : "";
        setFieldValue(otherEquipmentDetailsId, newValue);

    }
    useEffect(() => {
        if (equipmentDetailsList) {
            setOptions(equipmentDetailsList?.map((m) => { return { value: m.referenceId, label: m.value }; }));

        }
    }, [otherEquipmentDetailsValue, equipmentDetailsList])
    useEffect(() => {
        // if (!indicitave) {
        const values = otherEquipmentDetailsValue ? otherEquipmentDetailsValue.split(',') : [];
        setSelection(options?.filter(x => { return values.find(y => { return y === x.label }) }));
        // }
        // else {
        //     setSelection(otherEquipmentDetailsValue);
        // }
    },
        [otherEquipmentDetailsValue, options]);
    const aircraftPreference = (selection) => selection && selection.length ? selection.map(x => x.label).join(',') : null;
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <AircraftCategorySelector id='aircraftCategory' label='Category' />
                </Col>
                <Col>
                    <FormInput id='licenseNumber' label='Registration Number' maxLength={50} onChange={onAlphaNumericChange} />
                </Col>
                <Col>
                    <FormInput id='type' label='Make and Model' maxLength={50} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ManufacturerSelector id='manufacturer' label='Manufacturer' />
                </Col>
                <Col>
                    <FormInput id='serialNumber' label='Serial Number' maxLength={50} onChange={onAlphaNumericChange} />
                </Col>
                <Col>
                    <FormInput id='yearOfManufacture' label='Year of Manufacture' maxLength={4} onChange={onChange} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <SelectSetting endpoint={endpoints.getSettings + 'EngineConfiguration'} id='engineConfiguration' label='Engine Configuration' orderValues={true} />
                </Col>
                
                <Col>
                    <FormInput id='maximumTakeoffWeight' label='Maximum Takeoff Weight (kg)' maxLength={6} onChange={onChange} />
                </Col>
                <Col>
                    {isQGov?(docs && docs[0] ? <SpecialDocument key={docs[0]} doc={docs[0]} refresh={refresh} supplierId={supplierId} buttonName="View Aircraft Hours Document" /> : <FormLabel id="AircraftHoursDocument" style={{ display: 'block' }}>No Aircraft Hours Document</FormLabel>):null}
                </Col>
            </Row>
            <Row>
                <Col>
                    <BooleanInput id='isAircraftAirConditioned' label='Is the Aircraft air-conditioned?' />
                </Col>
                <Col>
                    <BooleanInput id='isAircraftPressurized' label='Is the Aircraft pressurized?' />
                </Col>
                <Col>
                    <FormInput id='passengerLimit' label='Passenger Limit' maxLength={4} onChange={onChange} />
                </Col>

            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <FormLabel htmlFor="otherEquipmentDetails">
                            Avionics, communications and other equipment details
                        </FormLabel>

                        {edit ? <Select onChange={onSelectChange} value={selection} isMulti options={options} name="otherEquipmentDetails" id="otherEquipmentDetails" /> :
                            <CompareFormValue originalContent={original ? aircraftPreference(originalSelection) : null} prefferedLabelColor={selection && selection[0]?.label === 'TWIN ENGINE ONLY' ? 'red' : null} >{aircraftPreference(selection)}</CompareFormValue>
                        }
                    </FormGroup>
                </Col>

                <Col>
                    <FormTextArea id='otherFeatures' label='Other Features' type='textarea' maxLength={500} />
                </Col>
                <Col>
                    <FormTextArea id='aircraftNotes' label='Notes' type='textarea' maxLength={1000} />
                </Col>
            </Row>
            <Row>
                <AircraftImages newImages={newImages} setNewImages={setNewImages} route={route} supplierId={values.supplierId} aircraft={values} />
            </Row>
        </Container>
    </React.Fragment>
};

export default AircraftDetail;




